import React, { useRef, useState } from 'react';
import { PauseSolidIcon, PlaySolidIcon } from '@fiverr-private/visuals';
import { IconButton } from '@fiverr-private/button';
import { Box } from '@fiverr-private/theme';
import { translate } from '@fiverr-private/i18n-react';

export const withToggleButton = (WrappedComponent) => {
    const WithToggleButton = (props) => {
        const videoRef = useRef(null);
        const [isPlaying, setIsPlaying] = useState(props.autoPlay);

        const handleTogglePlay = () => {
            if (videoRef.current) {
                if (isPlaying) {
                    videoRef.current.pause();
                } else {
                    videoRef.current.play();
                }

                setIsPlaying(!isPlaying);
            }
        };

        return (
            <Box position="relative" width={props.width} as="section">
                <WrappedComponent {...props} ref={videoRef} />

                <Box position="absolute" right="32px" bottom="32px" zIndex="2">
                    <IconButton
                        intent="primary"
                        shape="circle"
                        onClick={handleTogglePlay}
                        aria-label={translate('builder_components.video.toggle')}
                    >
                        {isPlaying ? <PauseSolidIcon color="white" /> : <PlaySolidIcon color="white" />}
                    </IconButton>
                </Box>
            </Box>
        );
    };

    return WithToggleButton;
};
